<template>
  <label :class="['pretty', 'p-default', 'p-curve']">
    <input
      type="checkbox"
      :name="name"
      :value="value"
      :checked="isChecked"
      :disabled="disabled"
      @change="onChange"
    />
    <div :class="['state', stateClass]">
      <label><slot /></label>
    </div>
  </label>
</template>

<script>
export default {
  name: 'p-check',
  props: {
    modelValue: { default: null },
    value: { default: null },
    name: { type: String, default: '' },
    color: { type: String, default: 'default' },
    disabled: { type: Boolean, default: false }
  },
  emits: ['update:modelValue'],
  computed: {
    isChecked () {
      if (Array.isArray(this.modelValue)) return this.modelValue.includes(this.value)
      return this.modelValue === this.value
    },
    stateClass () {
      return this.color !== 'default' ? `p-${this.color}` : ''
    }
  },
  methods: {
    onChange (e) {
      if (Array.isArray(this.modelValue)) {
        const arr = [...this.modelValue]
        if (e.target.checked) arr.push(this.value)
        else arr.splice(arr.indexOf(this.value), 1)
        this.$emit('update:modelValue', arr)
      } else {
        this.$emit('update:modelValue', e.target.checked ? this.value : null)
      }
    }
  }
}
</script>
